import { Text } from '@farmersdog/corgi-x';

import styles from './Callout.module.css';

interface CalloutArgs {
  vetName: string;
  dogName: string;
  isMobile: boolean;
}

export function Callout({ vetName, dogName, isMobile }: CalloutArgs) {
  return (
    <Text
      className={styles.callout}
      variant={isMobile ? 'heading-12' : 'heading-16'}
      bold
    >
      Good news, Dr. {vetName} already filled in some details for {dogName}!
    </Text>
  );
}
